import React, { FC } from "react";
import { faCircleQuestion } from "@fortawesome/pro-regular-svg-icons/faCircleQuestion";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const CircleQuestion: FC<
  JSX.IntrinsicAttributes & Omit<FontAwesomeIconProps, "icon">
> = (props) => <FontAwesomeIcon icon={faCircleQuestion} {...props} />;
